import { msg } from '@lingui/core/macro';

import { defineFilters } from '@/shared/filters/define-filters';
import type { CivilDate } from '@/shared/format/date';

import { FUND_EXECUTION_REQUESTED, WALLET_ORIGIN, WARRANTY_EXECUTION_STATUS } from './dataprev-employee.enums';

// Filtros da Execução de garantias (P01), na ordem do "Filtrar por" do legado
// (`WarrantyExecutionFilters.tsx:39-52`, `WarrantyExecutionListContainer.tsx:76-105`). Arquivo leve.

/**
 * Início do período como o legado manda: a meia-noite local escolhida no `DatePickerFormField` vira
 * `toISOString()` no `filterContext` (`getValueForUrl`, `filterContext.tsx:131-134`), em UTC. O fim segue
 * o padrão (`formatFinalDateWithTimeZone`).
 */
export function startInstantParam(day: CivilDate): string {
  return new Date(`${day}T00:00:00-03:00`).toISOString();
}

export const warrantyExecutionFilters = defineFilters([
  { key: 'executionStatus', type: 'select', label: msg`Status da execução`, options: WARRANTY_EXECUTION_STATUS },
  { key: 'isOwnFund', type: 'select', label: msg`Carteira`, options: WALLET_ORIGIN },
  { key: 'fundExecutionRequested', type: 'select', label: msg`Solicitado pelo fundo`, options: FUND_EXECUTION_REQUESTED },
  { key: 'creditNoteNo', type: 'text', label: msg`Número do contrato`, placeholder: msg`Filtrar por número do contrato`, max: 10 },
  { key: 'startDate', to: 'endDate', type: 'dateRange', label: msg`Data de atualização`, fromLabel: msg`Atualizado a partir de`, toLabel: msg`Atualizado até`, fromParam: startInstantParam },
  { key: 'executedFrom', to: 'executedTo', type: 'dateRange', label: msg`Data de execução`, fromLabel: msg`Executado a partir de`, toLabel: msg`Executado até`, fromParam: startInstantParam },
]);

/** Chave de início de cada período: é o que o `FilterProvider` do legado reconhece como filtro. */
export const WARRANTY_RANGE_STARTS: Readonly<Record<string, string>> = { endDate: 'startDate', executedTo: 'executedFrom' };
